/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { IconButton, Text, Popover } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../../../i18n/messages';
import { UnifiedTheme } from '../../../FeatureApp';

const Container = styled.div`
  position: relative;
`;
const Content = styled.div`
  max-width: 278px;

  background: ${(props: UnifiedTheme) =>
    process.env.IS_LEGACY ? props.theme.sys.color.canvas.default : 'transparent'};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  row-gap: 20px;
`;

const ButtonStyled = styled(IconButton)`
  margin: 0;
`;

export const ReviewDisclaimer = () => {
  const textParagraphs = useI18n(messages.five_star_review_tooltip)?.split(/[\r\n]+|(?<=\.)/);
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref?.current && !ref?.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  return (
    <Container ref={ref}>
      <Popover
        id="popover"
        triggerElement={
          <ButtonStyled
            variant="tertiary"
            icon="info-circle"
            size="sm"
            onClick={() => {
              setOpen(!open);
            }}
          />
        }
        open={open}
        content={
          <Content>
            {textParagraphs.map((line) => (
              <Text key={line}>{line}</Text>
            ))}
          </Content>
        }
        onClose={() => {}}
        withTip
        documentAnchor={ref?.current!}
      />
    </Container>
  );
};
